import { fontSize } from "@material-ui/system";
import { isAbsolute } from "upath";

export default (theme) => ({
  superContainer: {
    // background: "#F9F9F9",
    padding: 20,
  },
  mainContainer: {
    maxWidth: 1200,
    width: "100%",
    margin: "auto",
    background: "white"
  },
  subContainer: {
    display: "flex",
    width: "100%",
    justifyContent: "center"
  },
  leftContainer: {
    // width: "100%",
    maxWidth: 600,
    marginRight: 15,
    minWidth: 600,
    // padding: 10,
    // paddingRigh: 15
  },
  rightContainer: {
    width: 480,
    marginLeft: 15,
    position: "relative"
  },
  textCenter: {
    textAlign: 'center'
  },
  rsvpFormContainer: {
    // height: 470,
    // overflowY: "auto"
  },
  bannerContainer: {
    margin: 20,
    height: "100%"
  },
  bannerImageContainer: {
    width: "100%",
    '&:hover': {
      opacity: 0.3,
    },
  },
  buttonContainer: {
    display: "grid",
    width: 240,
    height: 100,
  },
  imageButtonContainer: {
    position: "relative"
  },
  headerContainer: {
    margin: 'auto',
    padding: "10px 44px"
  },
  venueContainer: {
    margin: "25px 0"
  },
  titleClass: {
    fontFamily: "Open Sans",
    fontWeight: "400",
    fontSize: 40,
    width: "auto",
    height: 62,
    marginLeft: 30
  },
  dateClass: {
    fontFamily: "Open Sans",
    fontWeight: "600",
    fontSize: 56,
    width: "auto",
    marginLeft: 30
  },
  subtitleClass: {
    fontFamily: "Raleway",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: 24,
    lineHeight: 38,
    letterSpacing: 0.25,
    height: 38
  },
  bodyClass: {
    fontFamily: "Open Sans",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: 18,
    letterSpacing: 0.25,
    color: "#333333",
    height: "240px",
    overflow: "hidden"
  },
  headerImageContainer: {
    // maxWidth: 286,
    margin: "20px 0px",
    maxHeight: 150,
    [theme.breakpoints.down('sm')]: {
      maxHeight: 100,
    },
  },
  footerImage: {
    maxHeight: 150,
    [theme.breakpoints.down('sm')]: {
      maxHeight: 100,
    },
  },
  labelContainer: {
    width: 900,
    height: 62,
  },
  editButton: {
    marginBottom: 10,
    height: 40
  },
  changeButton: {
    width: 240,
    marginTop: 10,
    opacity: 1,
    height: 40,
    boxShadow: "none",
    textTransform: "none",
    background: "white",
    "&:hover": {
      background: "white !important",
    }
  },
  rsvpFieldContainer: {
    color: "white !important",
    textAlign: "center",
    background: "#26BBED !important",
    position: "relative",
    height: 40
  },
  rsvpField: {
    color: "white !important",
    border: "none !important",
    textAlign: "center",
    background: "transparent !important",
    position: "absolute",
    bottom: 0,
    top: 0,
    left: 0,
    right: 0,
    width: "100%"
  },
  bannerBottom: {
    marginTop: 34,
    // width: 600
  },
  mainHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    background: "white",
    borderTop: "1px solid #eeeeee",
    borderBottom: "1px solid #eeeeee",
    paddingRight: 10
  },
  whiteIcon: {
    color: "white"
  },
  actionButton: {
    display: "flex",
    justifyContent: "space-between",
    width: 172,
    height: 32
  },
  buttonStyle: {
    width: 80,
    boxShadow: "none !important"
  },
  footer: {
    display: "flex",
    width: "100%",
    justifyContent: "center",
    padding: "40px 0",
  },
  bannerFrame: {
    // width: 600,
    minHeight: 340,
    position: "relative"
  },
  rsvpFormHeading: {
    fontSize: 28
  },
  inputStyle: {
    display: "none"
  },
  fileAttachContainer: {
    display: "flex",
    alignItems: 'center',
    justifyContent: 'left',
    marginTop: 16,
    width: "fit-content"
  },
  cursorStyle: {
    cursor: "pointer"
  },
  afterSelection: {
    background: "#F9F9F9",
    borderRadius: 2,
    padding: "6px 8px 6px 4px",
    height: 36,
  },
  attachFile: {
    fontFamily: "Open Sans",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: 14,
    color: "#4F6FAE",
    marginLeft: 4,
    lineHeight: "20px",
  },
  fileName: {
    fontFamily: "Open Sans",
    fontStyle: "normal",
    fontSize: 12,
    marginLeft: 4,
    lineHeight: "20px",
  },
  iconContainer: {
    width: 20,
    height: 20,
    marginRight: 4
  },
  deleteContainer: {
    width: 20,
    height: 20,
    marginLeft: 10,
  },
  iconRotate: {
    transform: "rotate(45deg)",
    color: "#333",
    marginRight: 10
  },
  flexContainer: {
    display: "flex",
    alignItems: 'center',
    justifyContent: 'left',
    "&:hover div": {
      color: "#26bbed !important",
    },
    "&:hover path": {
      stroke: "#26bbed",
    },
  },
  dialogRoot: {
    borderRadius: 0,
    width: 500,
    background: "white"
  },
  expansionRoot: {
    background: "white !important",
    borderRadius: "0 !important",
    boxShadow: "none",
    marginTop: 24
  },
  expansionBody: {
    margin: "0px -20px"
  },
  selectOptionPaper: {
    background: "white",
    padding: "16px",
    maxHeight: "350px"
  },
  selectOptionList: {
    cursor: "pointer",
    fontSize: 14,
    "&:hover": {
      color: "#26bbed"
    }
  },
  joinUsClass: {
    background: "transparent",
    width: 240,
    fontSize: 28,
    textAlign: "center",
    fontWeight: 600
  },
  buttonStyle: {
    textTransform: "none"
  },
  labelIndex: {
    zIndex: 2
  },
  formMargin: {
    marginBottom: 10,
    marginTop: 10,
    borderBottom: "1px solid #DADADA",
    width: "-webkit-fill-available",
    "&:hover": {
      borderBottom: "1px solid #26bbed !important"
    }
  },
  textFieldCss: {
    borderBottom: "1px solid #dadada !important",
    "&:hover": {
      borderBottom: "1px solid #26bbed !important"
    }
  },
  focusedCSS: {
    borderBottom: "1px solid #333 !important",
  },
  textEditor: {
    border: "1px solid #dadada",
    position: "relative",
    "&:hover": {
      border: "1px solid #26bbed",
    }
  },
  textEditorFocused: {
    border: "1px solid #999999 !important",
  },
  dateContainer: {
    position: 'relative'
  },
  recurranceContainer: {
    position: 'absolute',
    top: "21px",
    right: "20px",
    zIndex: 5,
  },
  messageBottom: {
    color: "#999999",
    opacity: 0.75,
    marginLeft: 8,
    fontSize: 12,
  },
})